export default {"src":"/_next/static/media/kenzie-logo.a14b3ec3.svg","height":45,"width":43};